import { ICON_DETAIL_PAGE } from "data/links";

export const getFormattedData = ({ slugWithId, response, isSubscription }) => {
    const isSubmitDisabled = false;
    const iconDetailLink = ICON_DETAIL_PAGE.replace(":slugWithId", slugWithId);

    const initialFormData = {
        name: "",
        address_zip: ""
    };

    return {
        initialForm: initialFormData,
        hasSavedCard:
            !isSubscription && response && Object.entries(response).length >= 1
                ? true
                : false,
        itemPrice: "2.99",
        isSubmitDisabled,
        iconDetailLink
    };
};
